export type DuplicateIds = {[key: string]: number[]};

export const getDuplicateIdList = (
    duplicateIds: DuplicateIds,
    cabinetId: string | number
): number[] => {
    const cabinetKey = String(cabinetId);
    const entry = Object.entries(duplicateIds).find(
        ([key]) => key === cabinetKey
    );

    return entry ? [...entry[1]] : [];
};

export const upsertDuplicateIdList = (
    duplicateIds: DuplicateIds,
    cabinetId: string | number,
    indexes: number[]
): DuplicateIds => {
    const cabinetKey = String(cabinetId);

    return Object.fromEntries([
        ...Object.entries(duplicateIds).filter(([key]) => key !== cabinetKey),
        [cabinetKey, indexes],
    ]) as DuplicateIds;
};

export const removeDuplicateIdIndex = (
    duplicateIds: DuplicateIds,
    cabinetId: string | number,
    duplicateId: number
): DuplicateIds => {
    const cabinetKey = String(cabinetId);
    const existing = Object.entries(duplicateIds).find(
        ([key]) => key === cabinetKey
    )?.[1];

    if (!existing) {
        return duplicateIds;
    }

    const nextList = existing.filter((id) => id !== duplicateId);

    return Object.fromEntries([
        ...Object.entries(duplicateIds).filter(([key]) => key !== cabinetKey),
        ...(nextList.length ? [[cabinetKey, nextList] as const] : []),
    ]) as DuplicateIds;
};

export const appendDuplicateIdIndex = (
    duplicateIds: DuplicateIds,
    cabinetId: string | number,
    index: number
): DuplicateIds => {
    const existing = getDuplicateIdList(duplicateIds, cabinetId);

    return upsertDuplicateIdList(duplicateIds, cabinetId, [...existing, index]);
};
